<template>
    <div id="buttonAtom" :class="['position-relative', extraAlign]">
		<button 
            class="btn btn-component" 
            :class="content.settings.size"
            :style="extraStyle"
        >
            {{ content.text }}
        </button>

        <div class="button-child-frame--container">
			<button 
                v-b-tooltip.hover
				title="Configuração do botão"
				v-if="showSettings"
				class="button-child-frame button-setting-button mb-1"
				@click="() => $emit('openSettingsFrameChild')"
			>
				<i class="fal fa-cog fa-md"></i>
			</button>

			<button
                v-b-tooltip.hover
				title="Excluir botão"
				v-if="showSettings"
				class="button-child-frame button-delete-button"
				@click="() => $emit('deleteFrameChild')"
			>
				<i class="fal fa-trash-alt fa-md"></i>
			</button>
		</div>
    </div>
</template>

<script>
export default {
    name: "ButtonBlock",
    props: {
        frameContent: {
            type: Object
        },
        showSettings: {
            type: Boolean,
            default: false,
        },
        extra: {
            type: Object,
            default: {},
        },
        defaultColors: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            content: {},
            valueExtra: {},
        }
    },
    computed: {
        extraStyle() {
            let style = {};

            style = {
                ...this.valueExtra.style,
            }

            if (!style.backgroundColor && this.defaultColors.backgroundDefault) {
                style.backgroundColor =  this.defaultColors.backgroundDefault;
            }

            if (!style.color && this.defaultColors.colorDefault) {
                style.color =  this.defaultColors.colorDefault;
            }

            if ((!style.fontWeight || this.valueExtra.style_font_weight_lock) && this.defaultColors.fontWeightDefault) {
                style.fontWeight =  this.defaultColors.fontWeightDefault;
            }

            if (this.valueExtra.style_font_size_lock) {
                style.fontSize = '';
            }

            if (this.valueExtra.style_border_radius_lock) {
                style.borderRadius = '';
            }

            style.textAlign = '';

            return style;
        },
        extraAlign() {
            let align = 'text-left';

            if (this.valueExtra.style && this.valueExtra.style.textAlign !== null && this.valueExtra.style.textAlign !== undefined) {
                align = `text-${this.valueExtra.style.textAlign}`;
            }

            return align;
        },
    },
    watch: {
        frameContent: function() {
            this.content = this.frameContent;
        },
        extra: {
            handler() {
                this.valueExtra = this.extra;
            },
            deep: true,
        },
    },
    created() {
        this.content = this.frameContent;

        if (this.extra) {
            this.valueExtra = this.extra;
        }
    },
}
</script>

<style>
#buttonAtom .btn-component {
    border-radius: 8px;
    padding: 10px 20px;
    border: none;
}

#buttonAtom .button-child-frame--container {
  position: absolute;
  top: -10px;
  bottom: 0;
  right: -12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#buttonAtom .button-child-frame {
  border: 1px solid #dddddd;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  min-width: 26px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#buttonAtom .button-child-frame:hover {
  background-color: var(--main-color);
  border: 1px solid var(--main-color);
  color: #fff;
}

#buttonAtom .button-child-frame {
  opacity: 0;
  transition: all 300ms ease-in-out;
}

#buttonAtom:hover .button-child-frame {
  opacity: 1;
  transition: all 300ms ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/ButtonBlock.vue